
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeSelectGrid extends _Ext.GridBase<ExchangeRow, any> {
        protected getColumnsKey() { return 'Retail.Exchange'; }
        protected getDialogType() { return ExchangeDialog; }
        protected getIdProperty() { return ExchangeRow.idProperty; }
        protected getInsertPermission() { return ExchangeRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeRow.localTextPrefix; }
        protected getService() { return ExchangeForReceiptService.baseUrl; } 
        private autoSize;
         
        constructor(container: JQuery, options) {
            super(container, options);
            var poscustomerid = options.GridFilters.CustomerId;
            var request = this.view.params as ReportFiltersRequest;
            request.POSCustomerId = poscustomerid; 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }
         
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);

            return grid;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        get selectedItems(): ExchangeRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {
            if (!super.onViewSubmit.call(this))
                return false;
            return true;

        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}